import { render } from "./Orders.vue?vue&type=template&id=19c6ee4e&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"

import "./Orders.vue?vue&type=style&index=0&id=19c6ee4e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19c6ee4e"

export default script